module.exports = __webpack_public_path__ + "assets/img/success.89e47beb.png";